'use strict';
import {stateGo} from 'redux-ui-router';
import 'rxjs/add/operator/combineLatest';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/switchMap';
import fuse from '../../../_libs/redux-fusion';
import {assetsStates} from '../../../assets/router-config';
import {getRouter} from '../../../config/reducers/state';
import {getId} from '../../../core-utilities/domain/ReduxUtils';
import {getNoteState} from '../../../system/components/NotificationPanelButton';
import {projectTasksStates} from '../../../tasks/router-config';
import {MenuTimerController} from '../../../timers/controllers/MenuTimerController';
import {updateProfileActions} from '../../../user-profile/actions';
import {selectedAsset, selectedProject} from '../../model/actions';
import {getModelState, getOrganization} from '../../model/reducers/state';
import {MainMenuComponent} from './MainMenuComponent';


// TODO(redux): retrieve from redux state once these are converted from legacy systems: unseenPriority, unseenChat, permissions
const StreamedComponent = (state$, dispatch) => (props$) => {
  const onSelectProject = project => {
    if (project) {
      dispatch(selectedProject(project.id));
      dispatch(stateGo(projectTasksStates.tasks));
    }
  };
  const onSelectAsset = asset => {
    if (asset) {
      dispatch(selectedAsset(asset.id));
      dispatch(stateGo(assetsStates.assetsHome));
    }
  };
  const onShowUserProfile = () => dispatch(updateProfileActions.showModal());

  const timerCtrl = new MenuTimerController(state$);

  const timerProps$ = timerCtrl.props$()
    .map(menuTimerProps => ({menuTimerProps}));

  const last$ = buildLast$(state$);

  const navState$ = state$
    .map(getRouter)
    .distinctUntilChanged();

  const modelState$ = state$
    .map(getModelState)
    .distinctUntilChanged();

  const noteState$ = state$
    .map(getNoteState)
    .distinctUntilChanged();

  return props$
    .combineLatest(
      timerProps$,
      last$,
      navState$,
      modelState$,
      noteState$,
      (props, timerProps, last, navState, modelState, noteState) => ({
        ...props,
        ...timerProps,
        ...last,
        navState,
        userProfile: modelState ? modelState.userProfile : null,
        modelState,
        noteState,
        onSelectProject,
        onSelectAsset,
        // Temporary:
        onShowUserMenu: onShowUserProfile,
      }));
};

export const MainMenuContainer = fuse(StreamedComponent)(MainMenuComponent);

// Required for ngRedux
MainMenuContainer.propTypes = MainMenuComponent.propTypes;

function buildLast$(state$) {
  return state$
    .map(state => getId(getOrganization(state)))
    .distinctUntilChanged()
    .filter(id => !!id)
    .switchMap(orgId =>
      state$
        .map(state => ({
          latestProjects: _dropFirstAndNulls(state.userPrefs.lastAccessedProjects[orgId] || []),
          latestAssets: _dropFirstAndNulls(state.userPrefs.lastAccessedAssets[orgId] || []),
        }))
    )
    .startWith({
      latestProjects: [],
      latestAssets: [],
    });
}

function _dropFirstAndNulls(latest) {
  const len = latest.length;
  return len < 2 ? [] : latest.slice(1, len);
}



// WEBPACK FOOTER //
// ./src/js/app/components/MainMenu/MainMenuContainer.js